// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11KcK","top":"styles_top__2sWoY","left":"styles_left__37uKT","description":"styles_description__26pKy"};